import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PropTypes from 'prop-types';
import { navigate } from '../../actions';
import CentroDia from '../centro_dia';
import CierreDiarioArcadeGrid from '../acc_cierre_diario/cierre_diario_arcade_grid';

import { withStyles } from '@material-ui/core/styles';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    
});

class EntLecturaMaqCambio extends Component {

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }


    };

    renderGastos = () => {
        if (this.props.centroDiaSelected.centro.id !== undefined && this.props.centroDiaSelected.dia !== '') {
            return (<CierreDiarioArcadeGrid />);
        }
    };

    render() {

        const { classes } = this.props;


        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />
                <CentroDia />

                {this.renderGastos()}
            </div>
        );

    };

};

EntLecturaMaqCambio.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    centroDiaSelected: PropTypes.object.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centroDiaSelected: state.centroDiaSelected
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(EntLecturaMaqCambio));